import React from 'react';
import { useRecoilValue } from 'recoil';
import { dimensionsAtom } from 'pages/dimensions/store/dimensions';
import { Param } from '../RoomParam';

export const WindowsSizes: React.FC = () => {
  const dimensions = useRecoilValue(dimensionsAtom);
  const { windows } = dimensions;

  if (windows?.sizes && windows?.sizes.length === 1) {
    return <Param label="Окно" value={`${windows?.sizes[0].height} x ${windows?.sizes[0].width} м`} />;
  }
  if (windows?.sizes && windows?.sizes.length > 1) {
    return (
      <>
        {windows?.sizes.map((window, index) => (
          <Param
            // eslint-disable-next-line react/no-array-index-key
            key={`${index}_${window.height}x${window.width}`}
            label={`Окно ${index + 1}`}
            value={`${window.height} x ${window.width} м`}
          />
        ))}
      </>
    );
  }

  return null;
};
